import type { FaireProductEntity } from "../../entity_types/product";

export const p_fa4mn9v22s: FaireProductEntity = {
  token: "p_fa4mn9v22s",
  type: "product",
  name: "Merino Triangle Scarf in Pink Stripe",
  brandToken: "b_de8058xhwh",
  brandName: "TBCo",
  imageUrl:
    "https://cdn.faire.com/fastly/781cadc9a581086a59cdb9aa6c30c9a59d5e32b75a7bfa982d5f90bbdba97f28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8debf861094ba7cfe56ddd79bc78b8e23ff9363d432673e4b281a964be8a115.jpeg",
    "https://cdn.faire.com/fastly/ea09418a27d16a1c3c5e23eb3d3084453e9be82d3770c0dc70e1438d8efca299.jpeg",
    "https://cdn.faire.com/fastly/59015bfdb54eb07119ad85d92fb64c0b0df33a346ee107ec4157a9d6a5c89c73.jpeg",
    "https://cdn.faire.com/fastly/4910ecfdf78622bf2daaae81f7bdeafc747ca314005b8da8e5ee90f949a8b74d.jpeg",
  ],
  priceDollars: 46.75,
  description:
    "There's a reason triangle scarves are our bestseller. Easily add interest and confidence to your outfit with this pink and burgundy striped triangle scarf knitted from soft and warm merino wool with an embroidered TBCo logo. It can be tied in multiple ways for endless styling options. Read more on our blog here.\n\nDesigned in our Edinburgh Studio. \n\nFibre | 100% Merino Wool\nSize | 110cm x 40cm\nWool Source | New Zealand \nWoven In | Inner Mongolia \nCare | Hand wash. Lay Flat to Dry.\nStyling | Trousers: Anthropologie\n\n\nBarcode | 5055603596738",
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:46.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
